/**
 * Tab list shared by the whole superadmin queue-monitoring family (worker
 * list + every per-jobType job list). Same shape/convention as
 * TabbedSettingsPage/settingsTabs.js. `to` omits the `/1` page segment so
 * SettingsTabs' non-exact NavLink matching still highlights the tab on
 * page 2+ (`:page?` routes resolve the bare path to page 1 already).
 */
export const QUEUE_TABS = [
  {
    key: "workers",
    label: "Queue workers",
    to: "/queue-workers",
    exact: false,
  },
  { key: "sync", label: "Sync jobs", to: "/sync-jobs", exact: false },
  { key: "webhooks", label: "Webhook jobs", to: "/webhook-jobs", exact: false },
  {
    key: "ics-update",
    label: "ICS update",
    to: "/ics-update-jobs",
    exact: false,
  },
  { key: "ics-clean", label: "ICS clean", to: "/ics-clean-jobs", exact: false },
  { key: "email", label: "Email jobs", to: "/email-jobs", exact: false },
];
